import client from '../api/client';

export const userAuthenticated = async () => {
  try {
    await client.get('/UsuarioAutenticado/');
    return true;
  } catch (error) {
    if (error.response?.status === 401) {
      return false;
    }
    throw error;
  }
};
